import { render, staticRenderFns } from "./LawProfessionalInvestigationTypeForm.vue?vue&type=template&id=cf63ae44&"
import script from "./LawProfessionalInvestigationTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawProfessionalInvestigationTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawProfessionalInvestigationTypeForm.vue?vue&type=style&index=0&id=cf63ae44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports